import styled from 'styled-components'

const Content = styled.div`
	flex: 1;
`
export default Content
